import { Zap, MapPin, Clock, Heart } from 'lucide-react';

const features = [
  {
    icon: Zap,
    text: "Real-Time Discovery",
    color: "bg-locale-primary"
  },
  {
    icon: MapPin,
    text: "Local Specials Near You",
    color: "bg-locale-secondary"
  },
  {
    icon: Clock,
    text: "Happy Hours, Classes, and Pop-Ups",
    color: "bg-locale-accent"
  },
  {
    icon: Heart,
    text: "Support Local Spots",
    color: "bg-locale-primary"
  }
];

export function ValuePropTags() {
  return (
    <section className="py-20 bg-transparent">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="font-poppins text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Everything you need to{' '}
            <span className="text-locale-primary">explore local</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Locale brings together real-time events, exclusive deals, and community connections in one beautifully simple app.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => {
            const IconComponent = feature.icon;
            return (
              <div
                key={index}
                className="group bg-gray-50 rounded-2xl p-6 text-center hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
              >
                <div className={`w-16 h-16 ${feature.color} rounded-xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300`}>
                  <IconComponent className="w-8 h-8 text-white" />
                </div>
                <h3 className="font-poppins font-semibold text-gray-900 mb-2">
                  {feature.text}
                </h3>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}